import React, { createContext, useState, useEffect, ReactNode } from 'react';
import { Employee } from '../types/backend.types';
import { authApi } from '../api/auth.api';

interface AuthContextType {
  user: Employee | null;
  token: string | null;
  login: (phone: string, pin: string) => Promise<void>;
  logout: () => void;
  isLoading: boolean;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [user, setUser] = useState<Employee | null>(null);
  const [token, setToken] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const storedToken = localStorage.getItem('bfa_token');
    const storedUser = localStorage.getItem('bfa_user');
    
    if (storedToken && storedUser) {
      setToken(storedToken);
      setUser(JSON.parse(storedUser));
    }
    setIsLoading(false);
  }, []);

  const login = async (phone: string, pin: string) => {
    const response = await authApi.login(phone, pin);
    if (response.success && response.data) {
      localStorage.setItem('bfa_token', response.data.token);
      localStorage.setItem('bfa_user', JSON.stringify(response.data.employee));
      setToken(response.data.token);
      setUser(response.data.employee);
    } else {
      throw new Error(response.error || 'Login failed');
    }
  };

  const logout = () => {
    localStorage.removeItem('bfa_token');
    localStorage.removeItem('bfa_user');
    setToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, token, login, logout, isLoading }}>
      {children}
    </AuthContext.Provider>
  );
};
